import React from 'react'

function Landingpage() {
  return (
    <div>
      <h1>Welcome to the Landing Page</h1>
    </div>
  )
}

export default Landingpage
